import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ErrorBannerProps {
    message: string;
    className?: string;
}

export function ErrorBanner({ message, className }: ErrorBannerProps) {
    return (
        <div className={cn(
            "p-3 rounded-xl bg-red-50 text-red-600 text-sm font-medium text-center border border-red-100 flex items-center justify-center gap-2",
            className
        )}>
            <AlertCircle size={16} className="flex-shrink-0" />
            {message}
        </div>
    );
}
